import _ from 'lodash';
import { useQuery } from '@apollo/client';
import { useContext, useEffect } from 'react';
import mapboxgl from 'mapbox-gl';
import { AzureMapsAttributionQuery } from '../queries';
import { MapContext } from '../contexts/MapContext';
import { setAttributionControl } from '../utils/map';

const getQueryVariables = (map) => ({
  bounds: map.getBounds().toArray().flat(),
  zoom: Math.floor(map.getZoom()),
});

export const AzureMapAttribution = ({ map }) => {
  const {
    mapState: { attributionControlRef },
  } = useContext(MapContext);
  const { data: attributionData, refetch } = useQuery(
    AzureMapsAttributionQuery,
    {
      variables: getQueryVariables(map),
    },
  );
  const attributionText = attributionData?.azureMapsAttribution;

  useEffect(() => {
    const debouncedRefetch = _.debounce(() => {
      refetch(getQueryVariables(map));
    }, 300);

    map.on('moveend', debouncedRefetch);
    map.on('zoomend', debouncedRefetch);

    // Initial fetch
    debouncedRefetch();

    return () => {
      map.off('moveend', debouncedRefetch);
      map.off('zoomend', debouncedRefetch);
    };
  }, [map, refetch]);

  useEffect(() => {
    if (!attributionText) return;

    const attributionControl = new mapboxgl.AttributionControl({
      customAttribution: attributionText,
    });
    setAttributionControl(map, attributionControl, attributionControlRef);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [attributionText]);

  useEffect(
    () => {
      return () => {
        const defaultAttributionControl = new mapboxgl.AttributionControl();
        setAttributionControl(
          map,
          defaultAttributionControl,
          attributionControlRef,
        );
      };
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  return null;
};
